export const flattenBodySchema = (nodes, prefix = "") => {
    const result = []
    for (const node of nodes) {
        const path = prefix ? `${prefix}.${node.key}` : node.key
        if (node.type === "object" && node.children?.length) {
            result.push(...flattenBodySchema(node.children, path))
        } else {
            result.push({ path, label: path, type: node.type, required: node.required, defaultValue: node.defaultValue ?? "" })
        }
    }
    return result
}
